import { client } from "../client/client";

export const getRoles = async () => {
  try {
    const response = await client.get("/roles");
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addRole = async (
  roleName,
  roleDescription,
  permissions,
  users
) => {
  try {
    const response = await client.post("/roles", {
      name: roleName,
      description: roleDescription,
      permission_ids: permissions,
      user_ids: users,
    });
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const editRole = async (
  roleId,
  roleName,
  roleDescription,
  permissions,
  users
) => {
  try {
    const response = await client.patch(`/roles/${roleId}`, {
      name: roleName,
      description: roleDescription,
      permission_ids: permissions,
      user_ids: users,
    });
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const deleteRole = async (id) => {
  try {
    const response = await client.delete(`/roles/${id}`);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addModule = async (name, description) => {
  try {
    const response = await client.post(`/modules`, {
      name,
      permissionAlias: description,
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addModulePermission = async (name, moduleId, moduleName) => {
  try {
    const response = await client.post(`/permissions`, {
      name,
      module_id: moduleId,
      module_name: moduleName,
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
